import { config } from "../../config";

export const DotMap2 = ({ data, map, markers = [], handleOnChange }) => {
	const { map_marker } = data;

	const onClick = (e) => {
		const rect = e.currentTarget.getBoundingClientRect();

		const diffs = {
			x: e.clientX - rect.x,
			y: e.clientY - rect.y,
		};
		const p = {
			x: (diffs.x / rect.width) * 100,
			y: (diffs.y / rect.height) * 100,
		};

		// console.log(p);
		// setPercentages(p);
		const newEvent = { target: { name: "map_marker", value: p } };
		handleOnChange(newEvent);
	};

	const clearPos = () => {
		const newEvent = { target: { name: "map_marker", value: {} } };
		handleOnChange(newEvent);
	};

	return (
		<div className="dot-map-holder2">
			<div className="dot-map-wrapper">
				<img
					src={`${config.siteUrl}${map.src}`}
					alt={map.src}
					width={map.width}
					height={map.height}
					className="map"
					onClick={onClick}
					style={{ cursor: "crosshair" }}
					draggable="false"
				/>
				{map_marker && map_marker?.x && map_marker?.y && (
					<MapMarker x={map_marker.x} y={map_marker.y} />
				)}
				{markers &&
					markers.map((marker, index) => (
						<MapMarker x={marker.x} y={marker.y} className="dim" key={index} />
					))}
			</div>
			{map_marker && map_marker?.x && map_marker?.y && (
				<button className="secondary" onClick={clearPos}>
					Poista merkintä
				</button>
			)}
		</div>
	);
};

export const DotsMap = ({ markers, map }) => {
	console.log("Markers", markers);
	return (
		<div className="dot-map-holder2">
			<div className="dot-map-wrapper">
				<img
					src={`${config.siteUrl}${map.src}`}
					alt={map.src}
					width={map.width}
					height={map.height}
					className="map"
					draggable="false"
				/>
				{markers &&
					markers.map((marker, index) => (
						<MapMarker x={marker.x} y={marker.y} />
					))}
			</div>
		</div>
	);
};

const MapMarker = ({ x, y, className }) => {
	return (
		<svg
			width="47"
			height="64"
			viewBox="0 0 47 64"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			style={{ left: x + "%", top: y + "%" }}
			className={`marker ${className}`}
		>
			<g clipPath="url(#clip0_71_306)">
				<path
					d="M23.155 62.768C21.6373 61.0917 0.381592 37.4015 0.381592 26.2514C0.381592 25.9513 0.415417 25.6467 0.485322 25.3489L0.489832 25.3308V25.3128C0.417672 24.5795 0.381592 23.8395 0.381592 23.1175C0.381592 10.5527 10.5991 0.329834 23.155 0.329834C35.7109 0.329834 45.9283 10.5527 45.9283 23.1152C45.9283 23.8395 45.8923 24.5773 45.8223 25.3105V25.3286L45.8246 25.3466C45.8923 25.6467 45.9283 25.949 45.9283 26.2491C45.9283 37.0789 24.6681 61.0714 23.155 62.7658V62.768ZM23.155 11.2318C16.7913 11.2318 11.6138 16.4121 11.6138 22.7791C11.6138 29.1461 16.7913 34.3263 23.155 34.3263C29.5186 34.3263 34.6961 29.1461 34.6961 22.7791C34.6961 16.4121 29.5186 11.2318 23.155 11.2318Z"
					fill="#00439A"
				/>
				<path
					d="M23.155 0.442661C35.6501 0.442661 45.8157 10.6136 45.8157 23.1153C45.8157 23.835 45.7796 24.5705 45.7097 25.3015L45.7052 25.3376L45.7142 25.3737C45.7818 25.6648 45.8157 25.9603 45.8157 26.2514C45.8157 32.0498 39.6189 41.6658 34.4188 48.7119C29.309 55.6362 24.136 61.4978 23.1528 62.6011C22.1673 61.5091 16.9989 55.7264 11.8913 48.8405C6.69345 41.8305 0.494422 32.2236 0.494422 26.2514C0.494422 25.9603 0.528247 25.6648 0.595898 25.3737L0.604918 25.3376L0.600408 25.3015C0.530502 24.5705 0.494422 23.835 0.494422 23.1153C0.494422 10.6136 10.66 0.442661 23.155 0.442661ZM23.155 34.4391C29.5796 34.4391 34.8089 29.2093 34.8089 22.7791C34.8089 16.3489 29.5818 11.119 23.155 11.119C16.7283 11.119 11.5011 16.3489 11.5011 22.7791C11.5011 29.2093 16.7283 34.4391 23.155 34.4391ZM23.155 0.217041C10.5157 0.217041 0.268921 10.4692 0.268921 23.1153C0.268921 23.8598 0.305001 24.5953 0.374906 25.3218C0.305001 25.6219 0.268921 25.931 0.268921 26.2491C0.268921 37.9318 23.155 62.935 23.155 62.935C23.155 62.935 46.0412 37.5956 46.0412 26.2491C46.0412 25.931 46.0028 25.6219 45.9352 25.3218C46.0051 24.5953 46.0412 23.8598 46.0412 23.1153C46.0434 10.4692 35.7966 0.217041 23.155 0.217041ZM23.155 34.2135C16.8433 34.2135 11.7266 29.0942 11.7266 22.7791C11.7266 16.464 16.8433 11.3446 23.155 11.3446C29.4668 11.3446 34.5834 16.464 34.5834 22.7791C34.5834 29.0942 29.4668 34.2135 23.155 34.2135Z"
					fill="#00439A"
				/>
			</g>
			<defs>
				<clipPath id="clip0_71_306">
					<rect
						width="46"
						height="63"
						fill="white"
						transform="translate(0.156128 0.104248)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};
